import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import {
  BizAppConfig,
  type BizAppServiceKey,
  type ExternalServiceConfig,
} from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

const normalizeServiceUrl = (serviceConfig?: ExternalServiceConfig) => {
  const baseUrl = serviceConfig?.baseUrl?.trim() || '';
  const basePath = serviceConfig?.basePath?.trim() || '';
  return `${baseUrl}${basePath}`;
};

export const createRequest = (baseURL?: string, timeout?: number) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(timeout ? { timeout } : {}),
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);

export const createServiceRequest = (serviceKey: BizAppServiceKey) => {
  const serviceConfig = BizAppConfig.services[serviceKey];
  return createRequest(
    normalizeServiceUrl(serviceConfig),
    serviceConfig?.timeout,
  );
};
